import cimg1 from '../images/case-studies/img-1.jpg'
import cimg2 from '../images/case-studies/img-2.jpg'
import cimg3 from '../images/case-studies/img-3.jpg'
import cimg4 from '../images/case-studies/img-4.jpg'
import cimg5 from '../images/case-studies/img-5.jpg'



const Cases = [
    {
        Id: '1',
        cTitle: 'Criminal Law', 
        slug: 'Criminal-Law',
        cImg:cimg1,
    },
    {
        Id: '2',
        cTitle: 'Family Law', 
        slug: 'Family-Law',
        cImg:cimg2,
    },
    {
        Id: '3',
        cTitle: 'Real Estate', 
        slug: 'Real-Estate',
        cImg:cimg3,
    },
    {
        Id: '4',
        cTitle: 'Business Law', 
        slug: 'Business-Law',
        cImg:cimg4,
    },
    {
        Id: '5',
        cTitle: 'Education Law', 
        slug: 'Criminal-Laws',
        cImg:cimg5,
    },
    {
        Id: '6',
        cTitle: 'Real Estate', 
        slug: 'Real-Estate',
        cImg:cimg3,
    },
]

export default Cases;